import React from 'react';
import { Modal } from 'antd';
import { branding } from '../config/branding';

const LoginModal = ({ open, onCancel }) => {
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
        >
            <div style={{ textAlign: 'center' }}>
                <img src={branding.logoSrc} alt={branding.logoAlt} style={{ height: 100 }} />
                <h4 style={{ fontSize: 15 }}>Sorry, you do not have access to this application, please contact your administrator.</h4>
            </div>
        </Modal>
    );
};

export default LoginModal;
